import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../../../environments/environment';
import { Category } from '../../../../core/services/categories/category.model';

@Injectable()
export class CategoriesService implements Resolve<any>
{
    categories: any[];
    onProductsChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private http: HttpClient
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {

        return new Promise((resolve, reject) => {

            Promise.all([
                this.getParents()
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getParents(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.http.get<Category[]>(`${environment.apiUrl}/categories`)
                .subscribe((response: any) => {
                    this.categories = response.filter(c => c.parentCategory === null);
                    this.onProductsChanged.next(this.categories);
                    resolve(this.categories);
                }, reject);
        });
    }

    getCategories(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.http.get(`${environment.apiUrl}/categories`)
                .subscribe((response: any) => {
                    this.categories = response;
                    this.onProductsChanged.next(this.categories);
                    resolve(response);
                }, reject);
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/categories/categories.service.ts